/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const InUri: core.serialization.ObjectSchema<serializers.InUri.Raw, Truvity.InUri> = core.serialization.object({
    values: core.serialization.list(core.serialization.string()),
});

export declare namespace InUri {
    export interface Raw {
        values: string[];
    }
}
